// extracted by mini-css-extract-plugin
export default {"MuiTooltip-arrow":"Tooltip_MuiTooltip-arrow__Ny4ZD","MuiTooltip-tooltip":"Tooltip_MuiTooltip-tooltip__85Vyf"};